import React__default from 'react';
import { isNamedComponent } from '../PageLayout/utils.js';

const getValidChildren = (rootComponent, child, validChildren, props) => {
  const validName = validChildren.find((_, key) => {
    return isNamedComponent(child, validChildren[key]);
  });
  if (validName && React__default.isValidElement(child)) {
    return React__default.cloneElement(child, props);
  } else {
    console.error(`${rootComponent} only accepts the following components: ${validChildren.join(', ')}`);
    return null;
  }
};

export { getValidChildren };
